export default __webpack_public_path__ + "static/media/adarsh.2ad54cfe.png";